/* ============
 * Embed Component
 * ============
 *
 * todo: add documentation here!
 */

import Forms from './../../utils/forms/forms';
import warehouseService from './../../services/warehouse';
import { mapMutations } from 'vuex';

export default {
  props: {

    /**
     * Data
     */
    type: {
      type: String,
      required: false,
    },
    entries: {
      type: Object,
      required: false,
    },
    queryProductWarehouse: {
      type: Function,
      required: false,
    },

  },
  data() {
    return {
      form: new Forms({
        minimumStockLevel: {
          value: '',
          type: 'number',
        },
      }),
      loading: false,
    };
  },

  mounted() {
    console.log(this.entries);
    this.form.minimumStockLevel = this.type === 'bulk' ? 0 : this.entries.minimumStockLevel;
  },
  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    update() {
      this.loading = true;
      const data = { minimumStock: this.form.minimumStockLevel };
      if (this.type === 'bulk') {
        data.warehouse_product_ids = this.entries.selected.map(item => (item.id));
      }
      warehouseService.stockManagement(this.entries.id, data, this.type)
        .then(() => {
          this.loading = false;
          this.unsetModalContent();
          this.toggleModal(false);
          this.queryProductWarehouse();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/minimumStock/minimumStock.js